/* Lead statuses API client.
 *
 * Replaces the old client-side registry in lib/leads.js, where
 * registerLeadStatus() mutated a module-level array. That mutation survived
 * navigation but not a refresh — nothing was ever sent to the server — which
 * is why a status created in Lead Settings vanished on reload.
 *
 * The server stores statuses in the lead_statuses table (see migration
 * 20260728170000_lead_status_table). `color` is a palette TOKEN, never a
 * Tailwind class string: Tailwind's JIT only generates classes it can find in
 * source, so a class held in a database row would render unstyled. The token
 * to class mapping lives in lib/leads.js as a literal object.
 */
import { api } from "./api";

const BASE = "/lead-statuses";

export const leadStatusesApi = {
  async list() {
    const r = await api.get(BASE);
    return r.statuses || [];
  },
  async create(label) {
    return api.post(BASE, { label });
  },
  async update(code, patch) {
    return api.patch(`${BASE}/${encodeURIComponent(code)}`, patch);
  },
  async remove(code) {
    return api.delete(`${BASE}/${encodeURIComponent(code)}`);
  },
};
